"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.expectedConnectionType = exports.canOpenConnectionFromBrowser = void 0;
const IConnection_1 = require("../connection/IConnection");
const DhtRpc_1 = require("../../generated/packages/dht/protos/DhtRpc");
const AddressTools_1 = require("./AddressTools");
const canOpenConnectionFromBrowser = (websocketServer) => {
    const hasPrivateAddress = ((websocketServer.host === 'localhost') || (0, AddressTools_1.isPrivateIPv4)(websocketServer.host));
    return websocketServer.tls || hasPrivateAddress;
};
exports.canOpenConnectionFromBrowser = canOpenConnectionFromBrowser;
const expectedConnectionType = (localPeerDescriptor, remotePeerDescriptor) => {
    if (remotePeerDescriptor.websocket
        && (localPeerDescriptor.type !== DhtRpc_1.NodeType.BROWSER || (0, exports.canOpenConnectionFromBrowser)(remotePeerDescriptor.websocket))) {
        return IConnection_1.ConnectionType.WEBSOCKET_CLIENT;
    }
    else if (localPeerDescriptor.websocket
        && (remotePeerDescriptor.type !== DhtRpc_1.NodeType.BROWSER || (0, exports.canOpenConnectionFromBrowser)(localPeerDescriptor.websocket))) {
        return IConnection_1.ConnectionType.WEBSOCKET_SERVER;
    }
    return IConnection_1.ConnectionType.WEBRTC;
};
exports.expectedConnectionType = expectedConnectionType;
//# sourceMappingURL=Connectivity.js.map